import { wrapPromise } from 'persist-promise/wrapPromise';
import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
import { Metrics } from '../metrics';
import { fetchConditionalPropertyRules } from './conditionalPropertyRulesApi';
const makeConditionalPropertyRulesFetchKey = ({
  portalId,
  frameworkTypeIdentifier,
  query
}) => {
  const params = new URLSearchParams();
  if (query !== null && query !== void 0 && query.includePipelineStageShim) {
    params.append('includePipelineStageShim', 'true');
  }
  if (query !== null && query !== void 0 && query.includeAssociationFields) {
    params.append('includeAssociationFields', 'true');
  }
  const queryString = params.toString() ? `?${params.toString()}` : '';
  return `conditional-property-rules-${portalId || 'current'}-${frameworkTypeIdentifier}${queryString}`;
};
const conditionalPropertyRulesPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'conditionalPropertyRules',
  deepFreeze: true,
  toCacheKey: makeConditionalPropertyRulesFetchKey,
  fetch: ({
    httpClient,
    frameworkTypeIdentifier,
    query
  }) => fetchConditionalPropertyRules(frameworkTypeIdentifier, httpClient, query)
});
export const makeConditionalPropertyRulesClient = ({
  httpClient,
  persistedPromise = conditionalPropertyRulesPersistedPromise
}) => Promise.resolve({
  debug: () => {
    persistedPromise.debug();
  },
  clearCache: () => {
    persistedPromise.clearCache();
    return Promise.resolve();
  },
  get: ({
    frameworkTypeIdentifier,
    query,
    refetch = false
  }) => {
    Metrics.counter('conditionalPropertyRules.get').increment();
    return persistedPromise.makeFetchWithOpts({
      allowEagerCacheReturn: isEarlyCacheReturnEnabled(),
      refresh: refetch
    })({
      httpClient,
      frameworkTypeIdentifier,
      query
    });
  }
});